import * as React from 'react';
import PropTypes from 'prop-types';

const ArrowCollapseDown = (props) => (
  <svg
    width="16"
    height="10"
    viewBox="0 0 16 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.46086 9.1763C7.85138 9.56688 8.48459 9.56691 8.87513 9.17636L15.4614 2.59013C15.8517 2.1998 15.8519 1.56703 15.4619 1.17642L14.9944 0.708338C14.6039 0.317252 13.9702 0.317131 13.5795 0.708069L8.16797 6.12313L2.75727 0.707722C2.3668 0.316908 1.73339 0.31677 1.34275 0.707414L0.875017 1.17515C0.484516 1.56565 0.484489 2.19877 0.874958 2.5893L7.46086 9.1763Z"
      fill={props.color || '#83858F'}
    />
  </svg>
);

ArrowCollapseDown.propTypes = {
  color: PropTypes.string,
};

export default ArrowCollapseDown;
